<template>
  <div style="width: 100%; height: 100%;pointer-events:all">
    <iframe
      style="width: 100%; height: 100%"
      src="http://app2.ainongye.cn/zt/api/bigdata/changfeng/berry/com/?hide=1"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'TraceIndex'
}
</script>



// WEBPACK FOOTER //
// src/components/trace/Index.vue